import React from 'react';

const ArrowLeft = () => (
  <svg fill="none" height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 6H.5M7.5 2l4 4-4 4" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default React.memo(ArrowLeft);
